import { render } from "./AddOperation.vue?vue&type=template&id=570590ba&ts=true"
import script from "./AddOperation.vue?vue&type=script&lang=ts"
export * from "./AddOperation.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__